import { render } from "./DefenseView.vue?vue&type=template&id=316d821e"
import script from "./DefenseView.vue?vue&type=script&lang=js"
export * from "./DefenseView.vue?vue&type=script&lang=js"

import "./DefenseView.vue?vue&type=style&index=0&id=316d821e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__